import { render, staticRenderFns } from "./FinalResult.vue?vue&type=template&id=3107e5bd&"
import script from "./FinalResult.vue?vue&type=script&lang=js&"
export * from "./FinalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports